import {PaymentStatusType} from "../../api/Constants";
import {Tag} from 'antd';

export const PaymentStatusWidget = ({status, props}) => {
    let tagColor = "#f55442";
    switch (status) {
        case PaymentStatusType.Recorded:
            tagColor = "#f55442";
            break;
        case PaymentStatusType.Invalid:
            tagColor = "#fa9f02";
            break;
        case PaymentStatusType.Verified:
            tagColor = "#0ea133";
            break;
        default:
    }

    return <Tag color={tagColor}>{PaymentStatusType.Label[status]}</Tag>
}